export const TITULO_PAGINA = 'Alterar Usuário Comercial de um Processo';
export const SUBTITULO_PAGINA = 'Informe o Processo que deseja alterar o Usuário Comercial.';

export const MAX_LENGTH_NUM_PROCESSO = 11;
export const MINIMO_PALAVRAS_JUSTIFICATIVA = 3;
export const MAX_COUNTER_JUSTIFICATIVA = 500;

export const LABEL_NUMERO_PROCESSO = 'Número do Processo:';
export const LABEL_CODIGO_COMERCIAL = 'Código do Usuário Comercial';
export const LABEL_NOME_COMERCIAL = 'Nome do Usuário Comercial';
export const LABEL_NOVO_CODIGO_COMERCIAL = 'Novo Código do Usuário Comercial*';
export const LABEL_CONSULTAR = 'Consultar';
export const LABEL_JUSTIFICATIVA = 'Justificativa*';
export const LABEL_ALTERAR = 'Alterar';

export const STATUS_USUARIO_ATIVO = 'A';

export const MENSAGEM_ERRO_BUSCA_PROCESSO = 'Nenhum resultado foi encontrado relacionado à sua pesquisa';
export const MENSAGEM_ERRO_BUSCA_COMERCIAL_NOVO = 'Nenhum resultado foi encontrado relacionado à sua pesquisa';
export const MENSAGEM_RESTRICAO_COMERCIAL_NOVO = 'O usuário informado está inativo ou não possui perfil comercial.';
export const MENSAGEM_SUCESSO_ALTERACAO = 'Usuário comercial do processo alterado com sucesso.';
export const MENSAGEM_ERRO_ALTERACAO = 'Não foi possível realizar a alteração do usuário comercial para este processo.';
export const MENSAGEM_CONFIRMACAO_ALTERACAO = 'O usuário comercial deste processo será alterado. Deseja continuar?';
export const MENSAGEM_ERRO_HISTORICO_AUTOMATICO = 'Usuário comercial alterado, mas não foi possível registrar o histórico automático desta alteração.';
